import { SimpleSelect } from "@/shared/ui/SimpleSelect";
import { Button, Input, useDebounceCallback } from "@devhop/ui";
import { useNavigate, useSearch } from "@tanstack/react-router";
import { XIcon } from "lucide-react";
import { useEffect, useState } from "react";
import { CLASS_ENROLLMENT_STATUS_LABELS } from "../lib/status";

type Search = {
  limit: number;
  offset: number;
  status?: string;
  phone?: string;
};

const STATUS_OPTIONS = [
  { value: "all", label: "ທຸກສະຖານະ" },
  ...Object.entries(CLASS_ENROLLMENT_STATUS_LABELS).map(([value, label]) => ({
    value,
    label,
  })),
];

export function ClassEnrollmentsFilter() {
  const nav = useNavigate({ from: "/app/class-enrollments" });
  const search = useSearch({ from: "/app/class-enrollments" }) as Search;
  const [phone, setPhone] = useState(search.phone ?? "");

  useEffect(() => {
    setPhone(search.phone ?? "");
  }, [search.phone]);

  const debounced = useDebounceCallback((value: string) => {
    nav({
      search: {
        ...search,
        phone: value.trim() || undefined,
        offset: 0,
      },
    });
  }, 400);

  const hasFilter = !!search.phone?.trim() || !!search.status;

  return (
    <div className="mb-4 flex flex-wrap items-center gap-2 px-2">
      <Input
        placeholder="ຄົ້ນຫາເບີໂທ..."
        value={phone}
        onChange={(event) => {
          setPhone(event.target.value);
          debounced(event.target.value);
        }}
        className="h-8 sm:max-w-xs"
      />
      <SimpleSelect
        value={search.status ?? "all"}
        onValueChange={(value) =>
          nav({
            search: {
              ...search,
              status: value === "all" ? undefined : value,
              offset: 0,
            },
          })
        }
        options={STATUS_OPTIONS}
        className="h-8 w-48"
      />
      {hasFilter ? (
        <Button
          variant="ghost"
          size="sm"
          onClick={() => {
            setPhone("");
            nav({ search: { limit: search.limit, offset: 0 } });
          }}
        >
          <XIcon className="size-4" />
          ລ້າງ
        </Button>
      ) : null}
    </div>
  );
}
